import Typography from '@hellodarwin/core/lib/components/common/typography';
import SummaryBox from '@hellodarwin/core/lib/components/grants/single/grant-sections/summary/summary-box';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
export const ApplicationProgressionFooterContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
export const ApplicationProgressionFooterInfo = styled(SummaryBox) `
  && {
    padding-block: 0 !important;
  }
`;
export const FooterRowContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.md}px;
  justify-content: space-between;
  align-items: center;

  ${media.l `
    flex-direction: column;
    gap: 6px;
    align-items: flex-start;
  `}
`;
export const FooterRowValue = styled(Typography) `
  ${media.l `
    padding-left: ${({ theme }) => theme.spacing.lg}px;
  `}
`;
export const FooterRowDateContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
  justify-content: space-between;
  align-items: start;
`;
export const FooterRowDateRow = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: fit-content;
  height: fit-content;
  line-height: 1;
  align-items: center;
`;
export const FooterRowLabelGroup = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: fit-content;
  height: fit-content;
  line-height: 1;
  align-items: center;
`;
export const FooterRowActions = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: fit-content;
  height: fit-content;
  line-height: 1;
  align-items: center;
`;
